import { type FC } from "react";

import { NavPill } from "@/pages/layouts/components/NavPill";
import { NotificationBell } from "@/pages/layouts/components/NotificationBell";
import { SupportAvatars } from "@/shared/components/SupportAvatars";
import { useIntercom } from "@/shared/providers/IntercomProvider";

interface PageActionsProps {
  showSupport?: boolean;
}

export const PageActions: FC<PageActionsProps> = ({ showSupport = true }) => {
  const { openSidePanel } = useIntercom();

  return (
    <>
      <div className="hidden lg:block">
        <NotificationBell />
      </div>
      <div className="block lg:hidden">
        <NotificationBell variant="icon" />
      </div>
      {showSupport && (
        <div className="hidden lg:block">
          <NavPill label="Get support" onClick={openSidePanel} className="h-8">
            <SupportAvatars />
          </NavPill>
        </div>
      )}
    </>
  );
};
